"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listMedicalAssistantsApiResponseSchema = exports.listMedicalAssistantsItemApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const enums_1 = require("./enums");
exports.listMedicalAssistantsItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('medical-assistants'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        contractType: enums_1.contractTypeSchema,
        weeklyHours: zod_1.z.number().int(),
        offices: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() })),
        hireDate: zod_1.z.coerce.date(),
        // ISO timestamp of the deactivation, null when active. Optional for
        // backward compatibility; the API always sends it. A soft-deleted profile
        // can no longer sign in.
        deactivatedAt: zod_1.z.string().nullable().optional(),
    }),
});
exports.listMedicalAssistantsApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.listMedicalAssistantsItemApiResponseSchema);
